<span class="rating">{{rating | number: '1.0-1'}}</span>
<ion-icon name="star" class="rating-icon"></ion-icon>
